import { Group, Paper, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export default function SectionCard({
  title,
  subtitle,
  action,
  children,
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Paper p="md" withBorder radius="md">
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="xs" mb="sm">
        <Stack gap={2}>
          <Text fw={FONT_WEIGHTS.semibold}>{title}</Text>
          {subtitle && (
            <Text size="textXs" c="dimmed">
              {subtitle}
            </Text>
          )}
        </Stack>
        {action}
      </Group>
      {children}
    </Paper>
  );
}
